import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideQuantityCalculatorMoreProductInfoPopUp } from '../Actions/QuantityCalculator.action';
import Popup from 'reactjs-popup';
import { translate } from '../Services/translation';

const QuantityCalculatorMoreProductInfoPopUp = () => {
    const dispatch = useDispatch();
    const { showQuantityCalculatorMoreProductInfoPopUp, productUrl } = useSelector((state) => state.quantityCalculator);  
    const hide = () => {
        dispatch(hideQuantityCalculatorMoreProductInfoPopUp());
    }
    const openProductUrlBlank = () => {
        window.open(productUrl, '_blank');
        hide();
    };

    return <Fragment>
        {showQuantityCalculatorMoreProductInfoPopUp && <Popup
                open={true}
                closeOnDocumentClick={false}
            >
                <div className="more-product-info">
                    <div className="modal">                       
                        <div className="content quantity-calculator__popup-wrapper">
                            <h3 className="more-product-info__title">
                                {translate("quantityCalculatorMoreProductInfoPopUpTitle")}
                            </h3>
                            <div className="more-product-info__content quantity-calculator__popup-content">
                                <p className="quantity-calculator__popup-paragraph">
                                    {translate("quantityCalculatorMoreProductInfoPopUpContent")}
                                </p>
                            </div>
                            <div className="more-product-info__buttons quantity-calculator__popup-buttons">
                                <button className="button button--ghost" onClick={() => hide()}>{translate("quantityCalculatorMoreProductInfoPopUpBtnAbort")}</button>
                                <button className="button button--buy-button quantity-calculator__popup-btn-continue" onClick={() => openProductUrlBlank()}>{translate("quantityCalculatorMoreProductInfoPopUpBtnContinue")}</button>
                            </div>                            
                        </div>
                    </div>
                </div>
            </Popup>}
    </Fragment>
}
export default QuantityCalculatorMoreProductInfoPopUp;